// Centralized configuration for the Sales Professional
export const repConfig = {
  name: "Horace Bell",
  title: "Senior Sales Consultant",
  phone: "(210) 330-3313",
  phoneClean: "2103303313",
  experience: "12+ Years Experience",
  tagline: "Personally helping families find the right vehicle since 2013.",
};